import { mainAxios } from "../../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "../../services/mainService";

/**
 * Este método trae un listado de todos los productos
 * bradescard
 */
export const getListaProductos = async () => {
  try {
    const response = await mainAxios.get(
      "/v1/productos/listaProductos",
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getProductoById = async (id) => {
  try {
    const response = await mainAxios.get(
      `/v1/producto/byId/${id}`,
      getDefaultHeaders()
    );


    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getProductosByFilters = async (body) => {
  try {
    const response = await mainAxios.post(
      "/v1/productos/list/filtros",
      body,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getProductoAnteriorDownSell = async (id) => { // Por producto anterior aqui nos referimos a productos de un nivel inferior Ej: Plus -> Medio -> Basico -> Downsell
  try {
    const response = await mainAxios.get(
      `/v1/producto/anterior?productoId=${id}`,
      getDefaultHeaders()
    );

    return response;
  }catch (error) {
    throw new Error(getErrorMessage(error));
  }
}

export const getProductoNivelInferior = async (id) => { // Por nivel inferior nos referimos el extremo más bajo de la jerarquia de productos (ej. Downsell en Plus -> Medio -> Basico -> Downsell)
  try {
    const response = await mainAxios.get(
      `/v1/producto/nivel-inferior?productoId=${id}`,
      getDefaultHeaders()
    );

    return response;
  }catch (error) {
    throw new Error(getErrorMessage(error));
  }
}
